const PreviousIcon = () => (
  <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.625 18.5311C8.42708 18.5311 8.22917 18.4582 8.07292 18.3019L1.28125 11.5103C0.177083 10.4061 0.177083 8.59359 1.28125 7.48942L8.07292 0.697754C8.375 0.395671 8.875 0.395671 9.17708 0.697754C9.47917 0.999837 9.47917 1.49984 9.17708 1.80192L2.38542 8.59359C1.88542 9.09359 1.88542 9.90609 2.38542 10.4061L9.17708 17.1978C9.47917 17.4998 9.47917 17.9998 9.17708 18.3019C9.02083 18.4478 8.82292 18.5311 8.625 18.5311Z" fill="#292D32"/>
  </svg>  
);

export default PreviousIcon;
